export const ServiceCallActions = {
  None: 0,
  Image: 1,
  Money: 2,
  ProblemSub: 3,
  Edit: 4,
  View: 5,
};